import { memo, useEffect, useState } from "react";
import { FormControl, InputLabel, Select, MenuItem, Box, CircularProgress, InputAdornment } from "@mui/material"
import Grid from '@mui/material/Grid2';
import { useNavigate, useParams } from "react-router-dom";
import { ILstFranquiasLiga, ILstLiga } from "../ferramentas-da-listagem/FerramentasDaListagem";
import { IListagemLigas, LigaService } from "../../services/api/liga/LigaService";
import { useAuthContext } from "../../contexts";
import { StringDecoder } from "string_decoder";
import { UtilidadeService } from "../../services/api/utilidades/UtilidadesService";
import { FranquiaService, IDetalheFranquia } from "../../services/api/franquia/FranquiaService";
import { IDadosModal } from "../modal/DialogMensagem";
import CookieService from "../../services/autenticacao/CookieService";

type IProps = {
    redirecionar: boolean
}


function CarregarDropLiga(props: IProps) {
    const { logout } = useAuthContext();
    const { id } = useParams<"id">();
    const user = CookieService.get("access_user");
    const [lstDadosLigaCard, setLstDadosLigaCard] = useState<IListagemLigas[]>([]);
    const [lstLiga, setLstLiga] = useState<ILstLiga[]>([]);
    const [codigoLiga, setCodigoLiga] = useState("");
    const navigate = useNavigate();
    const [lstDadosFranquiasLigaCard, setLstDadosFraqnuiasLigaCard] = useState<IDetalheFranquia[]>([]);
    const [lstFranquiasLiga, setLstFranquiasLiga] = useState<ILstFranquiasLiga[]>([]);
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [codigoFranquia, setCodigoFranquia] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [dadosModal, setDadosModal] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            let newCodigo = localStorage.getItem("@codigoLiga");
            await LigaService.getAllPorUsuario()
                .then((result) => {
                    const lst = result.data.dado;
                    let codigo = (lst.length === 0 || lst === null) ? "" : Math.max(...lst.map(m => m.codigo)).toString();
                    setLstDadosLigaCard(lst);
                    let listaDrop: ILstLiga[] = lstDadosLigaCard.map(l => ({ codigo: l.codigo, label: l.nome }));
                    setLstLiga(listaDrop);
                    //let newCodigo = localStorage.getItem("@codigoLiga");
                    setIsLoading(false);
                    if (newCodigo !== null) {
                        const resultCrypt = UtilidadeService.decrypt(newCodigo?.toString());
                        setCodigoLiga(resultCrypt !== undefined ? resultCrypt : "0");
                        if (user.administrador) {
                            CarregarFranquiasLiga(Number(resultCrypt));

                        }
                    }
                    else {
                        setIsLoading(false);
                        setCodigoLiga(codigo);
                        if (user.administrador) {
                            CarregarFranquiasLiga(Number(codigo));

                        }
                    }
                })
                .catch((errors) => {
                    setIsLoading(false);
                    if (errors.response.data.statusHTTP === 401) {
                        logout();
                        navigate(0);
                        return;
                    }
                });
        }
        fetchData();
    }, [codigoLiga, codigoFranquia]);

    const CarregarFranquiasLiga = async (codigoLiga: number) => {
        setIsLoading(true);
        await FranquiaService.getByIdLiga(codigoLiga)
            .then((result) => {
                const lstFranquias = result.dado;
                let minhaFranquia = lstFranquias.find(f => f.codigo_Usuario === user.codUsuario) !== undefined ? lstFranquias.find(f => f.codigo_Usuario === user.codUsuario)?.codigo : null;
                let codigo = (lstFranquias.length === 0 || lstFranquias === null) ? "" :
                    minhaFranquia != null ? minhaFranquia.toString()
                        : Math.max(...lstFranquias.map(m => m.codigo)).toString();
                setLstDadosFraqnuiasLigaCard(lstFranquias);
                let listaDrop: ILstFranquiasLiga[] = lstDadosFranquiasLigaCard.map(l => ({ codigo: l.codigo, label: l.nome, codigoUsuario: l.codigo_Usuario }));
                setLstFranquiasLiga(listaDrop);
                let newCodigoFranquia = localStorage.getItem("@codigoFranquia");
                if (newCodigoFranquia !== null && newCodigoFranquia !== "0") {
                    const resultCrypt = UtilidadeService.decrypt(newCodigoFranquia?.toString());
                    setCodigoFranquia(resultCrypt !== undefined ? resultCrypt : "0");
                }
                else {
                    setCodigoFranquia(codigo);
                }
                let codigoUsuarioSelecionado = localStorage.getItem("@codigoUsuFranquia");
                let codigoUsu = lstFranquias.find(f => f.codigo_Usuario === (codigoUsuarioSelecionado !== "0" ? Number(codigoUsuarioSelecionado) : Number(user.codUsuario)))?.codigo_Usuario;
                if (codigoUsu !== undefined && codigoUsu === user.codUsuario) {
                    let fraqnuiaUsuario = lstFranquias.find(f => f.codigo_Usuario === Number(user.codUsuario))?.codigo.toString();
                    newCodigoFranquia = null;
                    codigo = fraqnuiaUsuario !== undefined ? fraqnuiaUsuario : "0";
                    localStorage.setItem("@codigoUsuFranquia", Number(codigoUsu) !== undefined ? Number(codigoUsu).toString() : "0");
                    setCodigoFranquia(codigo);
                }
                else {
                    codigoUsu = lstFranquias.find(f => f.codigo === Number(codigo))?.codigo_Usuario;
                    localStorage.setItem("@codigoUsuFranquia", Number(codigoUsu) !== undefined ? Number(codigoUsu).toString() : "0");
                }
                setIsLoading(false);
                // if (user.administrador) {
                //     let cryptLiga = UtilidadeService.crypt(codigoLiga?.toString());
                //     navigate(`/usuario/liga/${cryptLiga}`);                    
                // }
            })
            .catch((errors) => {
                if (errors.response.data.statusHTTP === 401) {
                    logout();
                    navigate(0);
                    return;
                }
            });
    }

    const handleEscolhaLiga = async (e: { target: { name: string; value: any; }; }) => {
        setIsLoading(true);
        localStorage.setItem("@codigoLiga", "");
        setCodigoLiga(e.target.value);
        let crypt = UtilidadeService.crypt(e.target.value.toString());
        localStorage.setItem("@codigoLiga", crypt);
        localStorage.setItem("@codigoFranquia", "0");
        localStorage.setItem("@codigoUsuFranquia", "0");
        await CarregarFranquiasLiga(e.target.value);
        if (id !== null && id !== undefined) {
            navigate(`${window.location.pathname.replace(id, crypt)}`);
        }
        else {

            if (window.location.pathname === '/usuario/liga') {
                navigate(`${window.location.pathname}/${crypt}`);
            }
            else {
                navigate(0);
            }

        }
    }

    const handleEscolhaFranquiaLiga = (e: { target: { name: string; value: any; }; }) => {
        setIsLoading(true);
        localStorage.removeItem("@codigoUsuFranquia");
        setCodigoFranquia(e.target.value);
        let crypt = UtilidadeService.crypt(e.target.value.toString());
        localStorage.setItem("@codigoFranquia", crypt);
        let codigoUsuarioFranq = lstFranquiasLiga.find(f => f.codigo === e.target.value)?.codigoUsuario;

        localStorage.setItem("@codigoUsuFranquia", codigoUsuarioFranq !== undefined ? codigoUsuarioFranq.toString() : "0");

        if (codigoLiga !== undefined) {
            let cryptLiga = UtilidadeService.crypt(codigoLiga?.toString());
            if (id !== null && id !== undefined) {
                navigate(`${window.location.pathname.replace(id, cryptLiga)}`);
            }
            else {
                if (window.location.pathname === '/usuario/liga') {
                    navigate(`${window.location.pathname}/${crypt}`);
                }
                else {
                    navigate(0);
                }
            }
        }
    }

    return (
        <Grid container size={{ xs: 12, sm: 12 }} paddingTop={2} display="flex" padding={0} >
            <Grid size={{ xs: 12, sm: 6 }} padding={1}>
                <FormControl sx={{ width: "100%" }}>
                    <InputLabel id="demo-simple-select-helper-label">Liga</InputLabel>
                    <Select
                        label="Liga"
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        value={codigoLiga.toString()}
                        onChange={handleEscolhaLiga}
                        defaultValue=""
                        variant="filled"
                        sx={{ height: "42px", width: "100%" }}
                        endAdornment={
                            <InputAdornment position="end">
                                {isLoading ? <CircularProgress size={UtilidadeService.isMobile() ? 16 : 28} /> : undefined}
                            </InputAdornment>
                        }
                    >
                        {/* <MenuItem key={0} value="0">Selecione...</MenuItem> */}
                        {
                            lstLiga.map((liga, i) => <MenuItem key={`MenuItem${liga.codigo}${i}`} value={liga.codigo}>{`${liga.codigo} - ${liga.label}`}</MenuItem>)
                        }
                    </Select>
                </FormControl>
            </Grid>
            {user.administrador && (
                <Grid size={{ xs: 12, sm: 6 }} >
                    <Box sx={{ width: UtilidadeService.isMobile() ? "298px" : "100%", paddingLeft: "8px", paddingTop: "8px" }}>
                        <FormControl sx={{ width: "100%" }}>
                            <InputLabel id="demo-simple-select-helper-label">Franquias</InputLabel>
                            <Select
                                label="Franquias"
                                labelId="demo-simple-select-helper-label"
                                id="demo-simple-select-helper"
                                value={codigoFranquia}
                                onChange={handleEscolhaFranquiaLiga}
                                variant="filled"
                                sx={{ height: "42px", width: "100%" }}
                                endAdornment={
                                    <InputAdornment position="end">
                                        {isLoading ? <CircularProgress size={UtilidadeService.isMobile() ? 16 : 28} /> : undefined}
                                    </InputAdornment>
                                }

                            >
                                {/* <MenuItem key={0} value="0">Selecione...</MenuItem> */}
                                {
                                    lstFranquiasLiga.map((liga, i) => <MenuItem key={`MenuItem${liga.codigo}${i}`} value={liga.codigo}>{`${liga.codigo} - ${liga.label}`}</MenuItem>)
                                }
                            </Select>
                        </FormControl>
                    </Box>
                </Grid>
            )}
        </Grid>

    )
}

export default memo(CarregarDropLiga);